import type { PositionResponse } from "@patent-studio/api-types";
import { ConfirmDialog } from "@/components/ui/ConfirmDialog";

/** The explicit step before a position is removed, naming it. */
export function RemoveConfirmation({
  position,
  onCancel,
  onConfirm,
}: {
  position: PositionResponse | null;
  onCancel: () => void;
  onConfirm: (position: PositionResponse) => void;
}) {
  return (
    <ConfirmDialog
      open={position !== null}
      title={`Remove ${position?.title ?? "this position"}?`}
      description="It comes off the list and out of the analysis. The positions after it renumber."
      actionLabel="Remove position"
      destructive
      onCancel={onCancel}
      onConfirm={() => {
        if (position !== null) onConfirm(position);
      }}
    />
  );
}
